export const refs = {
  categoryList: document.querySelector('.categories'),
  productList: document.querySelector('.products'),
  divNotFound: document.querySelector('.not-found'),
  form: document.querySelector('.search-form'),
};


